export const MICROSERVICES = {
    example: '/example',
    impersonation: '/impersonation/agent/v1',
};
